import { z } from "zod";
import { requiredError } from "./errors";
import type { CreateLinkConfig } from "~/utils/types";
import type {
  DemoRequest,
  DemoRequestRegister,
  DemoRequestType,
} from "@gasparigit/omnia-sdk";

export const userFormSchema = {
  name: z.string(requiredError).describe("Nome"),
  surname: z.string(requiredError).describe("Cognome"),
  email: z
    .string(requiredError)
    .trim()
    .email("Email non valida")
    .describe("Email"),
  phone: z.string(requiredError).describe("Telefono").optional().nullable(),
};

export const userFieldConfigs = {
  name: {
    inputProps: { autocomplete: "given-name" },
  },
  surname: {
    inputProps: { autocomplete: "family-name" },
  },
  email: {
    inputProps: { autocomplete: "email" },
  },
  phone: {
    inputProps: { autocomplete: "tel" },
  },
};

export function createDemoRequest(
  type: DemoRequestType,
  values: any,
  linkConfig?: CreateLinkConfig
) {
  const demoRequest = { ...values, type: type } as DemoRequestRegister;

  demoRequest.ref = useRoute().fullPath;
  demoRequest.area_id = linkConfig?.area?.id;
  demoRequest.content_id = linkConfig?.content?.id;
  demoRequest.hub_id = linkConfig?.hub?.id;
  demoRequest.memoweb_id = linkConfig?.memoweb?.id;
  demoRequest.menu_ids = linkConfig?.chain?.map((m) =>
    typeof m === "number" ? m : m.id
  );

  return demoRequest;
}
